// src/theme/components/form.js
// Form, FormControl, FormLabel için tema tanımları

import { formAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(formAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    width: '100%',
    minWidth: 0,
  },
  requiredIndicator: {
    marginStart: 1,
    color: 'red.500',
  },
  helperText: {
    mt: 2,
    color: 'textSecondary',
    lineHeight: 'normal',
    fontSize: 'sm',
  },
});

export const Form = defineMultiStyleConfig({
  baseStyle,
});
